import { FunctionComponent, useRef, useEffect } from 'react';
import styles from '../../styles/components/chat/FieldPanel.module.css';

interface FieldPanelProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onToolsClick: (anchorRect?: DOMRect) => void;
  disabled?: boolean;
}

const FieldPanel: FunctionComponent<FieldPanelProps> = ({
  value,
  onChange,
  onSend,
  onKeyDown,
  onToolsClick,
  disabled = false,
}) => {
  const settingsBtnRef = useRef<HTMLDivElement>(null);
  const anchorRef = useRef<HTMLDivElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-resize functionality
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = 'auto';
      // Set height to scrollHeight, but with min and max constraints
      const scrollHeight = textarea.scrollHeight;
      const minHeight = 24; // Single line height
      const maxHeight = 200; // Maximum height before scrolling
      const newHeight = Math.min(Math.max(scrollHeight, minHeight), maxHeight);
      textarea.style.height = `${newHeight}px`;
    }
  }, [value]);

  return (
    <div className={styles.fieldPanel}>
      <div className={styles.fieldPanel1} ref={anchorRef}>
        <div className={styles.fieldText}>
          <textarea
            ref={textareaRef}
            value={value}
            onChange={e => onChange(e.target.value)}
            onKeyDown={onKeyDown}
            placeholder="Ask anything"
            className={styles.text}
            disabled={disabled}
            rows={1}
          />
        </div>
        <div className={styles.frameParent}>
          <div className={styles.tagsParent}>
            <div
              ref={settingsBtnRef}
              className={styles.tags}
              onClick={() => {
                const rect = anchorRef.current?.getBoundingClientRect();
                onToolsClick(rect);
              }}
            >
              <img
                className={styles.leftIcon}
                alt=""
                src="/icons/chat/settings.svg"
              />
            </div>
            <div className={styles.tags1}>
              <img className={styles.leftIcon} alt="" src="/icons/search.svg" />
              <div className={styles.testWrap}>
                <div className={styles.text1}>Search</div>
              </div>
            </div>
          </div>
          <div className={styles.tagsGroup}>
            <div className={styles.tags} onClick={() => {}}>
              <img
                className={styles.leftIcon}
                alt=""
                src="/icons/chat/add_file.svg"
              />
            </div>
            <div className={styles.button} onClick={onSend}>
              <div className={styles.textWrap}>
                <div className={styles.text1}>Generate</div>
              </div>
              <img
                className={styles.leftIcon}
                alt=""
                src="/icons/chevron_up.svg"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.text3}>
        AI can make mistakes. We recommend checking important information
      </div>
    </div>
  );
};

export default FieldPanel;
